import Header from "./page/Navbar.jsx";
import Homepage from "./page/Homepage.jsx";
import About from "./page/About.jsx";
import Footer from "./page/Footer.jsx";



function App() {
  return (
    <>
      <Header />
      <div style={{ paddingTop: "80px" }}> {/* Space for fixed header */}
        <Homepage />
        <About />
      </div>
      <Footer />
    </>
  );
}

export default App;
